import React, { useState } from 'react';
import Loader from '../../components/Loader';
import { I18n, T } from '../../utils/I18n/I18n';

const CheckoutContinueButton = ({ pickupRef, onContinue, isDisabled }) => {
  const [loader, setLoader] = useState(false);

  const onClick = () => {
    if (pickupRef.current) {
      pickupRef.current
        .submit()
        .then(() => onContinue(), err => console.error(err))
        .finally(() => setLoader(false));

      setLoader(true);
    } else {
      onContinue();
    }
  };

  return (
    <div className="checkout__continue">
      {loader ? (
        <Loader height="xl" />
      ) : (
        <I18n>
          {t => (
            <button
              className="checkout__btn checkout__btn--secondary"
              disabled={isDisabled}
              onClick={onClick}
              title={t('cartSummary.continueToCheckout')}
              type="button"
            >
              <T id="cartSummary.continueToCheckout" />
            </button>
          )}
        </I18n>
      )}
    </div>
  );
};

export default CheckoutContinueButton;
